// extracted by mini-css-extract-plugin
module.exports = {"change-email":"C67_ChangeEmail_change-email__FI2RW"};